import React from 'react';
import SVGUniqueID from 'react-svg-unique-id';

interface DiscountTagIconProps {
  width?: number;
  height?: number;
  fill?: string;
}

const DiscountTagIcon: React.FC<DiscountTagIconProps> = (props) => {
  const { width = 24, height = 35, fill = '#15803d' } = props;

  return (
    <SVGUniqueID>
      <svg
        xmlns="http://www.w3.org/2000/svg"
        width={width}
        height={height}
        viewBox="0 0 24 35"
        fill="none"
      >
        <path
          d="M10.77 8.457a1.23 1.23 0 0 1 1.913 0l.82 1.015c.306.378.806.54 1.276.414l1.26-.338a1.23 1.23 0 0 1 1.548 1.124l.068 1.304c.025.485.334.91.788 1.085l1.22.467a1.23 1.23 0 0 1 .59 1.819l-.712 1.094a1.23 1.23 0 0 0 0 1.341l.712 1.095a1.23 1.23 0 0 1-.59 1.819l-1.22.467a1.23 1.23 0 0 0-.788 1.085l-.068 1.304a1.23 1.23 0 0 1-1.547 1.124l-1.26-.34a1.23 1.23 0 0 0-1.276.415l-.821 1.016a1.23 1.23 0 0 1-1.913 0l-.82-1.016a1.23 1.23 0 0 0-1.276-.414l-1.261.339a1.23 1.23 0 0 1-1.548-1.124l-.067-1.304a1.23 1.23 0 0 0-.788-1.085l-1.22-.467a1.23 1.23 0 0 1-.59-1.82l.711-1.094a1.23 1.23 0 0 0 0-1.341L3.2 15.347a1.23 1.23 0 0 1 .592-1.82l1.219-.466c.454-.174.763-.6.788-1.085l.067-1.304a1.23 1.23 0 0 1 1.548-1.125l1.26.34c.47.126.97-.037 1.276-.415z"
          stroke={fill}
          strokeWidth={1.23}
        />
        <path
          d="M9.551 14.759c.616 0 1.114-.728 1.114-1.626s-.498-1.625-1.114-1.625c-.615 0-1.114.728-1.114 1.625 0 .898.5 1.626 1.114 1.626Zm4.903 6.824c.615 0 1.114-.728 1.114-1.625 0-.898-.499-1.626-1.114-1.626s-1.114.728-1.114 1.626.499 1.625 1.114 1.625Z"
          stroke={fill}
          strokeWidth={1.23}
        />
        <path
          d="m10.27 21.488 3.463-9.884"
          stroke={fill}
          strokeWidth={1.23}
          strokeLinecap="round"
        />
      </svg>
    </SVGUniqueID>
  );
};

export { DiscountTagIcon };
